import { fetchInappCheckoutShippingHowItWorks } from '@/assets/ts/apiManagement'

export default class CheckoutShippingHowItWorksView extends HTMLElement {
	promise: Promise<string>

	constructor() {
		super()
		const shadow = this.attachShadow({ mode: 'open' })

		this.promise = fetchInappCheckoutShippingHowItWorks().then(
			(res: { data: string }) => {
				const appendStyle = `
          <style>
            h1 {
              display: none;
            }
          </style>
        `

				const htmlMarkupFormat = res.data
					.replace('</head>', `${appendStyle}</head>`)
					.replace('<body', '<div')
					.replace('</body>', '</div>')
					.replace(/<a/gi, '<a target="_blank"')

				shadow.innerHTML = htmlMarkupFormat

				const re = '\\<h1\\>(.+)\\<\\/h1\\>'
				const titleMatch = res.data.match(re)
				return titleMatch ? titleMatch[1] : ''
			},
		)
	}
}
